import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource } from '@atlassian/react-resource-router';
import type { QueryEndpointResponse } from './types.tsx';

const body = { providers: ['issueLinks', 'dependencySettings'] };
const url = '/rest/jpo/1.0/info/query';

const fetchIssueLinkInformation = (): Promise<QueryEndpointResponse> =>
	performPostRequest(url, { body: JSON.stringify(body) });

export const issueLinkInformationResource = createResource<QueryEndpointResponse>({
	type: 'ISSUE_LINK_INFORMATION',
	getKey: () => 'issue-link-information',
	getData: async () => fetchIssueLinkInformation(),
	maxAge: 0,
});
